import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const RNFI_DiagnosticAx = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='RNFI_DiagnosticAx' className='file-pdf-document'>
            <div className='file-template'>


            <p className='w-750'><h2>Common Items</h2></p>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Participant Accompanied By</span>
            <span className='small'>(check all that apply)</span>
        </td>
    </tr>
    <tr>
        <td className='w-187'><input type='checkbox' name='cbParticipantAccompaniedBy_1' id='cbParticipantAccompaniedBy_1' className='add-only' value='Self' /> Self</td>
        <td className='w-187'><input type='checkbox' name='cbParticipantAccompaniedBy_2' id='cbParticipantAccompaniedBy_2' className='add-only' value='Family' /> Family</td>
        <td className='w-187'><input type='checkbox' name='cbParticipantAccompaniedBy_2' id='cbParticipantAccompaniedBy_2' className='add-only' value='SignificantOther' /> Significant Other</td>
        <td className='w-187'><input type='checkbox' name='cbParticipantAccompaniedBy_4' id='cbParticipantAccompaniedBy_4' className='add-only' value='LegalGuardian' /> Legal Guardian</td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='checkbox' name='cbParticipantAccompaniedByOther' id='cbParticipantAccompaniedByOther' className='add-only' value='Other' /> Other : &nbsp;
            <input type='text' id='txtParticipantAccompaniedByOther' name='txtParticipantAccompaniedByOther' className='add-only w-350 custom-add-only' />
        </td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Legal Guardian/Custodian Name</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtLegalGuardianCustodianName' name='txtLegalGuardianCustodianName' className='add-only' /></td>
    </tr>
</table>

<table>

    <tr>
        <td className='w-750'>
            <span className='eleHeader'>History of Present Problem(s)</span>
            <span className='small'>(When began, duration/intensity of symptons, stressors/precipitants, list participants conception of presenting
                problems and what the participant perceives to be the important issues to be addressed.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHistoryPresentProblem' name='txtHistoryPresentProblem' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Prior MH/SA/DD History</span>
            <span className='small'>(When began, duration/intensity of symptons, stressors/precipitants, list participants conception of presenting
                problems and what the participant perceives to be the important issues to be addressed.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPriorMhSaDdHistory' name='txtPriorMhSaDdHistory' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>History of Traumatic Events</span>
            <span className='small'>(Consider neglect or abuse, violence, significant losses, accidents, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHistoryTraumaticEvents' name='txtHistoryTraumaticEvents' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Current Living Situation</span>
            <span className='small'>(Where, with whom, relationship, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Education History</span>
            <span className='small'>(Consider special education, behavior programs, grade level - current or achieved, school, attitude, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtEducationHistory' name='txtEducationHistory' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Vocational History</span>
            <span className='small'>(Include current Employment, military, vocational difficulties, handicaps, if unemployed - work plan, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtVocationalHistory' name='txtVocationalHistory' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Family History</span>
            <span className='small'>(Include any MH/DD/SA history of biological family, immediate family/significant others, diagnosis, treatment, etc.)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtFamilyHistory' name='txtFamilyHistory' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Social History</span>
            <span className='small'>(Include friendships, significant relationships, religious and cultural activities, hobbies, recreation)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSocialHistory' name='txtSocialHistory' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'><span className='eleHeader'>Transcultural Factors</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtTransculturalFactors' name='txtTransculturalFactors' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Primary Language</span></td>
    </tr>
    <tr>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_1' name='rbPrimaryLanguage' className='add-only' value='English' /> English</td>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_2' name='rbPrimaryLanguage' className='add-only' value='SignLanguage' /> Sign Language</td>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_3' name='rbPrimaryLanguage' className='add-only' value='French' /> French</td>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_4' name='rbPrimaryLanguage' className='add-only' value='Spanish' /> Spanish</td>
    </tr>
    <tr>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_5' name='rbPrimaryLanguage' className='add-only' value='None' /> None</td>
        <td className='w-187'><input type='radio' id='rbPrimaryLanguage_6' name='rbPrimaryLanguage' className='add-only' value='Unknown' /> Unknown</td>
    </tr>
    <tr>
        <td className='w-750'><input type='radio' id='rbPrimaryLanguageOther' name='rbPrimaryLanguage' className='add-only' value='Other' /> Other : &nbsp;
            <input type='text' id='txtPrimaryLanguageOther' name='txtPrimaryLanguageOther' className='add-only w-350 custom-add-only' />
        </td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Consumer Residence</span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_1' name='rbConsumerResidence' className='add-only' value='PrivateResidenceAlone' /> Private Residence (Alone)</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_2' name='rbConsumerResidence' className='add-only' value='PrivateResidenceWithOthers' /> Private Residence (with Others)</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_3' name='rbConsumerResidence' className='add-only' value='OtherIndependent' /> Other Independent</td>
    </tr>
    <tr>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_4' name='rbConsumerResidence' className='add-only' value='Homeless' /> Homeless</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_5' name='rbConsumerResidence' className='add-only' value='CorrectionalFacility' /> Correctional Facility</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_6' name='rbConsumerResidence' className='add-only' value='Institution' /> Institution</td>
    </tr>
    <tr>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_7' name='rbConsumerResidence' className='add-only' value='ResidentialFacilityNotNursing' /> Residential Facility (Not Nursing)</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_8' name='rbConsumerResidence' className='add-only' value='FosterFamilyAfl' /> Foster Family/AFL</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_9' name='rbConsumerResidence' className='add-only' value='NursingHomeIcfSnf' /> Nursing Home (ICF, SNF)</td>
    </tr>
    <tr>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_10' name='rbConsumerResidence' className='add-only' value='AdultCareHome7Beds' /> Adult Care home (&#62;= 7 beds)</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_11' name='rbConsumerResidence' className='add-only' value='AdultCareHome6Beds' /> Adult Care home (&#60;= 6 beds)</td>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_12' name='rbConsumerResidence' className='add-only' value='CommunityIfcMr69Beds' /> Community IFC-MR (&#60;=69 beds)</td>
    </tr>
    <tr>
        <td className='w-250'><input type='radio' id='rbConsumerResidence_13' name='rbConsumerResidence' className='add-only' value='CommunityIfcMr70Beds)' /> Community IFC-MR (&#62;=70 beds)</td>
    </tr>
    <tr>
        <td className='w-750'><input type='radio' id='rbConsumerResidenceOther' name='rbConsumerResidence' className='add-only' value='Other' /> Other : &nbsp;
            <input type='text' id='txtConsumerResidenceOther' name='txtConsumerResidenceOther' className='add-only w-350 custom-add-only' />
        </td>
    </tr>
</table>

<p className='w-750'><h3>Evaluation Process</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Provider Organization</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtProviderOrganization' name='txtProviderOrganization' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Clinical Accessors and Credentials</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClinicalAccessorsCredentials' name='txtClinicalAccessorsCredentials' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Collateral Persons Involved in Assessment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCollateralPersonsInvolvedAssessment' name='txtCollateralPersonsInvolvedAssessment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Collateral Information Used</span>
            <span className='small'>(ex: records, etc)</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCollateralInformationUsed' name='txtCollateralInformationUsed' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Clinical Home Agency</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtClinicalHomeAgency' name='txtClinicalHomeAgency' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Reasons for Seeking Services</h3></p>


<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Referred for assessment of</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtReferredForAssessmentOf' name='txtReferredForAssessmentOf' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'><span className='eleHeader'>Presenting Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPresentingProblems' name='txtPresentingProblems' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'><span className='eleHeader'>Other Sources of Distress</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtOtherSourcesOfDistress' name='txtOtherSourcesOfDistress' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Precipitating Events</span>
            <span className='small'>Why seeking services NOW?</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtPrecipitatingEvents' name='txtPrecipitatingEvents' className='add-only' /></td>
    </tr>



    <tr>
        <td className='w-750'><span className='eleHeader'>Recent Progression of Problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtRecentProgressionOfProblems' name='txtRecentProgressionOfProblems' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>General Health History</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Problems and Symptoms</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtProblemsAndSymptoms' name='txtProblemsAndSymptoms' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtTreatment' name='txtTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Response to Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtResponseToTreatment' name='txtResponseToTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Attitudes about Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAttitudesAboutTreatment' name='txtAttitudesAboutTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Factors contributing or inhibiting previous recovery</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtFactorsContributingInhibitingPreviousRecovery' name='txtFactorsContributingInhibitingPreviousRecovery' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Known allergies and adverse medication reactions</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtKnownAllergiesAdverseMedicationReactions' name='txtKnownAllergiesAdverseMedicationReactions' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Has the client ever had tuberculosis?</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtHasTheClientEverHadTuberculosis' name='txtHasTheClientEverHadTuberculosis' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h2>Mental Health Treatment History</h2></p>
<p className='w-750'><h3>Outpatient</h3></p>

<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMhthOutcome_1' name='txtMhthOutcome_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtMhthOutcome_2' name='txtMhthOutcome_2' className='add-only' /></td>
    </tr>
</table>



<p className='w-750'><h3>IOP/Outpatient</h3></p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMhthIopOutcome_1' name='txtMhthIopOutcome_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtMhthIopOutcome_2' name='txtMhthIopOutcome_2' className='add-only' /></td>
    </tr>
</table>



<p className='w-750'><h3>Inpatient/Residential</h3></p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtMhthInpatientResidential_1' name='txtMhthInpatientResidential_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtMhthInpatientResidential_2' name='txtMhthInpatientResidential_2' className='add-only' /></td>
    </tr>
</table>



<p className='w-750'><h3><b>Number of psychiatric hospitalizations</b></h3></p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>In the past 12 months</span></td>
        <td className='w-375'><span className='eleHeader'>In lifetime</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtInThePastYear' name='txtInThePastYear' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtInLifetime_1' name='txtInLifetime_1' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Additional MH Treatment History/Information</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAdditionalMhTreatmentHistoryInformation' name='txtAdditionalMhTreatmentHistoryInformation' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h2>Current Psychotropic Medications</h2></p>
<table>
    <tr>
        <td className='w-350'><span className='eleHeader'>Medication Name</span></td>
        <td className='w-150'><span className='eleHeader'>Dose</span></td>
        <td className='w-150'><span className='eleHeader'>Frequency</span></td>
        <td className='w-100'><span className='eleHeader'>Usually Adherent?</span></td>
    </tr>


    <tr>
        <td className='w-350'><input type='text' id='txtCurrentPsychotropicMedicationsMedicationName_1' name='txtCurrentPsychotropicMedicationsMedicationName_1' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsDose_1' name='txtCurrentPsychotropicMedicationsDose_1' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsFrequency_1' name='txtCurrentPsychotropicMedicationsFrequency_1' className='add-only' /></td>
        <td className='w-100'>
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_1Yes' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_1' className='add-only' value='Yes' /> Yes &nbsp;
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_1No' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_1' className='add-only' value='No' /> No &nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-350'><input type='text' id='txtCurrentPsychotropicMedicationsMedicationName_2' name='txtCurrentPsychotropicMedicationsMedicationName_2' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsDose_2' name='txtCurrentPsychotropicMedicationsDose_2' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsFrequency_2' name='txtCurrentPsychotropicMedicationsFrequency_2' className='add-only' /></td>
        <td className='w-100'>
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_2Yes' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_2' className='add-only' value='Yes' /> Yes &nbsp;
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_2No' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_2' className='add-only' value='No' /> No &nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-350'><input type='text' id='txtCurrentPsychotropicMedicationsMedicationName_3' name='txtCurrentPsychotropicMedicationsMedicationName_3' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsDose_3' name='txtCurrentPsychotropicMedicationsDose_3' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsFrequency_3' name='txtCurrentPsychotropicMedicationsFrequency_3' className='add-only' /></td>
        <td className='w-100'>
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_3Yes' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_3' className='add-only' value='Yes' /> Yes &nbsp;
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_3No' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_3' className='add-only' value='No' /> No &nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-350'><input type='text' id='txtCurrentPsychotropicMedicationsMedicationName_4' name='txtCurrentPsychotropicMedicationsMedicationName_4' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsDose_4' name='txtCurrentPsychotropicMedicationsDose_4' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsFrequency_4' name='txtCurrentPsychotropicMedicationsFrequency_4' className='add-only' /></td>
        <td className='w-100'>
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_4Yes' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_4' className='add-only' value='Yes' /> Yes &nbsp;
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_4No' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_4' className='add-only' value='No' /> No &nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-350'><input type='text' id='txtCurrentPsychotropicMedicationsMedicationName_5' name='txtCurrentPsychotropicMedicationsMedicationName_5' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsDose_5' name='txtCurrentPsychotropicMedicationsDose_5' className='add-only' /></td>
        <td className='w-150'><input type='text' id='txtCurrentPsychotropicMedicationsFrequency_5' name='txtCurrentPsychotropicMedicationsFrequency_5' className='add-only' /></td>
        <td className='w-100'>
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_5Yes' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_5' className='add-only' value='Yes' /> Yes &nbsp;
            <input type='radio' id='rbCurrentPsychotropicMedicationsUsuallyAdherent_5No' name='rbCurrentPsychotropicMedicationsUsuallyAdherent_5' className='add-only' value='No' /> No &nbsp;
        </td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Medication History</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtMedicationHistory' name='txtMedicationHistory' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h2>Diagnostic Impression</h2></p>
<table>
    <tr>
        <td className='w-50'><span className='eleHeader'>#</span></td>
        <td className='w-550'><span className='eleHeader'>Diagnosis</span></td>
        <td className='w-150'><span className='eleHeader'>Date</span></td>
    </tr>
    <tr>
        <td className='w-50'>(1)</td>
        <td className='w-550'><input type='text' id='txtDiagnosticImpressionDiagnosis_1' name='txtDiagnosticImpressionDiagnosis_1' className='add-only' /></td>
        <td className='w-150'><input type='date' id='txtDiagnosticImpressionDate_1' name='txtDiagnosticImpressionDate_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-50'>(2)</td>
        <td className='w-550'><input type='text' id='txtDiagnosticImpressionDiagnosis_2' name='txtDiagnosticImpressionDiagnosis_2' className='add-only' /></td>
        <td className='w-150'><input type='date' id='txtDiagnosticImpressionDate_2' name='txtDiagnosticImpressionDate_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-50'>(3)</td>
        <td className='w-550'><input type='text' id='txtDiagnosticImpressionDiagnosis_3' name='txtDiagnosticImpressionDiagnosis_3' className='add-only' /></td>
        <td className='w-150'><input type='date' id='txtDiagnosticImpressionDate_3' name='txtDiagnosticImpressionDate_3' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-50'>(4)</td>
        <td className='w-550'><input type='text' id='txtDiagnosticImpressionDiagnosis_4' name='txtDiagnosticImpressionDiagnosis_4' className='add-only' /></td>
        <td className='w-150'><input type='date' id='txtDiagnosticImpressionDate_4' name='txtDiagnosticImpressionDate_4' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-50'>(5)</td>
        <td className='w-550'><input type='text' id='txtDiagnosticImpressionDiagnosis_5' name='txtDiagnosticImpressionDiagnosis_5' className='add-only' /></td>
        <td className='w-150'><input type='date' id='txtDiagnosticImpressionDate_5' name='txtDiagnosticImpressionDate_5' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h2>Substance Abuse Treatment History</h2></p>
<p className='w-750'><h3>Outpatient</h3></p>

<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtSathOutcome_1' name='txtSathOutcome_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtSathOutcome_2' name='txtSathOutcome_2' className='add-only' /></td>
    </tr>
</table>



<p className='w-750'><h3>IOP/Outpatient</h3></p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtSathIopOutcome_1' name='txtSathIopOutcome_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtSathIopOutcome_2' name='txtSathIopOutcome_2' className='add-only' /></td>
    </tr>
</table>



<p className='w-750'><h3>Inpatient/Residential</h3></p>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome</span></td>
        <td className='w-375'><span className='eleHeader'>Treatment Compliance</span><span className='small'>(non-med)</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtSathInpatientResidential_1' name='txtSathInpatientResidential_1' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtSathInpatientResidential_2' name='txtSathInpatientResidential_2' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h2><span className='eleHeader'>Alcohol & Drug Use</span></h2>
    <textarea id='txtAlcoholDrugUse' name='txtAlcoholDrugUse' className='add-only'></textarea>
</p>
<p className='w-750'><h2><span className='eleHeader'>Comments</span></h2>
    <textarea id='txtAlcoholDrugUseComments' name='txtAlcoholDrugUseComments' className='add-only'></textarea>
</p>


<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current/Recent Abuse Indicators</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentRecentAbuseIndicators' name='txtCurrentRecentAbuseIndicators' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Current/Recent Dependence Indicators</span></td></tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCurrentRecentDependenceIndicators' name='txtCurrentRecentDependenceIndicators' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>SA Diagnostic Tool(s) used</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSaDiagnosticToolUsed' name='txtSaDiagnosticToolUsed' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Assessment Results</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAssessmentResults' name='txtAssessmentResults' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>N.C. Modified A/ASAM Placement Level</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtNcModifiedAsamPlacementLevel' name='txtNcModifiedAsamPlacementLevel' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h2>Developmental Disabilities History</h2></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Problems and Symptoms</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDdhProblemsAndSymptoms' name='txtDdhProblemsAndSymptoms' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDdhTreatment' name='txtDdhTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Response to Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDdhResponseToTreatment' name='txtDdhResponseToTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Attitudes about Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDdhAttitudesAboutTreatment' name='txtDdhAttitudesAboutTreatment' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Factors contributing or inhibiting previous recovery</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDdhFactorsContributingPreviousRecovery' name='txtDdhFactorsContributingPreviousRecovery' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h2>Consumer's Supports</h2></p>
<p className='w-750'><h3>Ability to Care for Self</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Competency Status</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppCompetencyStatus' name='txtConsumerSuppCompetencyStatus' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Self care deficits or problems</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppSelfDeficitsProblems' name='txtConsumerSuppSelfDeficitsProblems' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Primary Support Group</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppPrimarySupportGroup' name='txtConsumerSuppPrimarySupportGroup' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Friendships and Social Supports</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppFriendshipsSocialSupports' name='txtConsumerSuppFriendshipsSocialSupports' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>History of Abuse or Neglect</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppHistoryAbuseNeglect' name='txtConsumerSuppHistoryAbuseNeglect' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Relevant Family History</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerSuppRelevantFamilyHistory' name='txtConsumerSuppRelevantFamilyHistory' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h2>Employment</h2></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Employment Status</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtEmploymentStatus' name='txtEmploymentStatus' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-750'><span className='eleHeader'>Employment Strengths/Challenges</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtEmploymentStrengthsChallenges' name='txtEmploymentStrengthsChallenges' className='add-only' /></td>
    </tr>
</table>


<p className='w-750'><h2>Consumer's Strengths & Limitations</h2></p>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Describe consumer's strengths and limitations</span>
            <span className='small'>In areas that affect treatment, including housing, financial, access to health care,
                legal, co-morbidity, recovery environment, and treatment and recovery history</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtDescribeConsumerStrengthsLimitations' name='txtDescribeConsumerStrengthsLimitations' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><span className='eleHeader'>Other Assessment Information & Data</span>
    <textarea id='txtConsumerStrengthLimitationsOtherAssessmentInformationData' name='txtConsumerStrengthLimitationsOtherAssessmentInformationData' className='add-only' ></textarea>
</p>


<table>
    <tr>
        <td className='w-750'><h2>Current Impairments</h2></td>
    </tr>
    <tr>
        <td className='w-750'><h3><b>Scale : 0 = None, 1 = Mild, 2 = Moderate, 3 =  Severe, N/A = Not Assessed</b></h3></td>
    </tr>


    <tr>
        <td className='w-250'><span className='eleHeader'>Mood Disturbance </span><span className='small'>(Depression or mania)</span></td>
        <td className='w-250'><span className='eleHeader'>Anxiety </span></td>
        <td className='w-250'><span className='eleHeader'>Psychosis </span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_1' name='txtCurrentImpairments_1' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_2' name='txtCurrentImpairments_2' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_3' name='txtCurrentImpairments_3' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-250'><span className='eleHeader'>Thinking/Cognition/Memory </span></td>
        <td className='w-250'><span className='eleHeader'>Impulsive/Reckless Aggressive </span></td>
        <td className='w-250'><span className='eleHeader'>Activities of Daily Living </span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_4' name='txtCurrentImpairments_4' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_5' name='txtCurrentImpairments_5' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_6' name='txtCurrentImpairments_6' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-250'><span className='eleHeader'>Medical/Physical Condition(s) </span></td>
        <td className='w-250'><span className='eleHeader'>Job/School Performance </span></td>
        <td className='w-250'><span className='eleHeader'>Legal </span></td>
    </tr>
    <tr>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_7' name='txtCurrentImpairments_7' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_8' name='txtCurrentImpairments_8' className='add-only' /></td>
        <td className='w-250'><input type='text' id='txtCurrentImpairments_9' name='txtCurrentImpairments_9' className='add-only' /></td>
    </tr>


    <tr>
        <td className='w-375'><span className='eleHeader'>Weight Loss Associated with Eating Disorder </span></td>
        <td className='w-375'><span className='eleHeader'>Social/Marital/Family Problems </span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtCurrentImpairments_10' name='txtCurrentImpairments_10' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtCurrentImpairments_11' name='txtCurrentImpairments_11' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Assessment Interpretation & Case Formulation</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtAssessmentInterpretationCaseFormulation' name='txtAssessmentInterpretationCaseFormulation' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h2>Consumer's Treatment/Recovery Goals</h2></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Goals</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtCtrgGoals' name='txtCtrgGoals' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'><h3>Goals & Objectives</h3></p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Goal #1</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtGoalsObjectiveGoal_1' name='txtGoalsObjectiveGoal_1' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-375'><span className='eleHeader'>Outcome Measurement Tool</span></td>
        <td className='w-375'><span className='eleHeader'>Anticipate Date of Achievement</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='text' id='txtOutcomeMeasurementTool' name='txtOutcomeMeasurementTool' className='add-only' /></td>
        <td className='w-375'><input type='text' id='txtAnticipateDateAchievement' name='txtAnticipateDateAchievement' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Objective #1</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtGoalsObjective_1' name='txtGoalsObjective_1' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Interverntion(s) for Objective #1</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtInterverntionObjective_1' name='txtInterverntionObjective_1' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><span className='eleHeader'>Consumer's Readiness & Motivation to Engage in Treatment</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtConsumerReadinessMotivationEngageTreatment' name='txtConsumerReadinessMotivationEngageTreatment' className='add-only' /></td>
    </tr>
</table>

<p className='w-750'>
    <span className='eleHeader'>Assessors' Treatment/Service Recommendations</span>
    <textarea id='txtAssessorsTreatmentServiceRecommendations' name='txtAssessorsTreatmentServiceRecommendations' className='add-only' ></textarea>
</p>

<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Team Review Date</span></td>
    </tr>
    <tr>
        <td className='w-375'><input type='date' id='txtTeamReviewDate' name='txtTeamReviewDate' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Participants</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtParticipants' name='txtParticipants' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'><span className='eleHeader'>Summary of Discussion and Recommendations</span></td>
    </tr>
    <tr>
        <td className='w-750'><input type='text' id='txtSummaryDiscussionRecommendations' name='txtSummaryDiscussionRecommendations' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-750'><input type='checkbox' id='cbSummaryDiscussionRecommendationIndividual' name='cbSummaryDiscussionRecommendationIndividual' className='add-only' value='Individual' />
        Individual was educated on and verbally acknowledged the risks and benefits of the medications listed within this note via telehealth.</td>
    </tr>
</table>


            </div>
        </form>

    )
}  
 